import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Item, Stagger } from './Reveal';

// Adapted from Watermelon UI block "cta-1" (split CTA card with blurred polygon glows).
const blob =
  'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)';

export default function CTA() {
  return (
    <section className="bg-paper px-5 pb-24 sm:px-8 lg:px-12 lg:pb-32">
      <Stagger
        amount={0.4}
        className="relative isolate mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 overflow-hidden rounded-2xl bg-forest px-7 py-14 text-paper md:flex-row md:items-center md:px-14 md:py-20"
      >
        <div aria-hidden="true" className="absolute left-[-8rem] top-1/2 -z-10 -translate-y-1/2 blur-2xl">
          <div style={{ clipPath: blob }} className="aspect-[577/310] w-[36rem] bg-gradient-to-r from-sage to-amber/60 opacity-40" />
        </div>
        <div aria-hidden="true" className="absolute right-[-10rem] top-1/2 -z-10 -translate-y-1/2 blur-2xl">
          <div style={{ clipPath: blob }} className="aspect-[577/310] w-[36rem] bg-gradient-to-r from-sage/80 to-sage opacity-30" />
        </div>

        <div className="max-w-2xl">
          <Item as="h2" className="text-4xl font-normal leading-[1.05] tracking-[-0.045em] text-balance sm:text-5xl">
            Ready to take your business to{' '}
            <span className="font-serif italic tracking-[-0.02em] text-amber">new heights?</span>
          </Item>
          <Item as="p" className="mt-5 max-w-lg text-paper/75">
            Join us on the journey to success. Tell us where you want to go, and we&rsquo;ll build the strategy
            to get you there.
          </Item>
        </div>

        <Item className="w-full shrink-0 md:w-auto">
          <Link
            to="/#contact"
            className="group inline-flex h-12 w-full items-center justify-center gap-2 rounded-sm bg-paper px-8 text-base font-medium text-ink shadow-[inset_0_2px_4px_rgba(255,255,255,0.5),inset_0_-2px_5px_rgba(0,0,0,0.1),0_8px_20px_rgba(0,0,0,0.2)] transition-transform active:scale-[0.97] md:w-auto"
          >
            Start the conversation
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
        </Item>
      </Stagger>
    </section>
  );
}
